import React, { useEffect, useState } from 'react';
import PageHeader from '../../components/PageHeader';
import DataTable from '../../components/DataTable';
import Avatar from '../../components/Avatar';
import * as usersApi from '../../api/users.api';
import { errorMessage } from '../../api/client';
import { formatDate } from '../../utils/format';
import { ROLES } from '../../utils/roles';

function Admins() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [roleFilter, setRoleFilter] = useState('');
  const [err, setErr] = useState('');

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    Promise.all([
      usersApi.listAdminUsers({ role: 'ADMIN' }),
      usersApi.listAdminUsers({ role: 'STAFF' }),
      usersApi.listAdminUsers({ role: 'SUPER_ADMIN' })
    ])
      .then(([a, s, sa]) => {
        if (cancelled) return;
        const all = [...(sa || []), ...(a || []), ...(s || [])];
        const filtered = roleFilter ? all.filter((u) => u.role === roleFilter) : all;
        setRows(filtered);
      })
      .catch((e) => { if (!cancelled) setErr(errorMessage(e)); })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, [roleFilter]);

  return (
    <>
      <PageHeader title="Internal staff" subtitle="Super-admins, admins and staff. No end users or clinics here." />
      <DataTable
        loading={loading}
        rows={rows}
        searchPlaceholder="Search by name, email…"
        toolbarRight={
          <select className="select" style={{ width: 180 }} value={roleFilter} onChange={(e) => setRoleFilter(e.target.value)}>
            <option value="">All</option>
            <option value={ROLES.SUPER_ADMIN}>Super Admin</option>
            <option value={ROLES.ADMIN}>Admin</option>
            <option value={ROLES.STAFF}>Staff</option>
          </select>
        }
        columns={[
          {
            key: 'name',
            header: 'Person',
            render: (r) => (
              <div className="row">
                <Avatar name={r.name} />
                <div>
                  <div className="cell-strong">{r.name}</div>
                  <div className="muted text-xs">{r.email}</div>
                </div>
              </div>
            )
          },
          { key: 'role', header: 'Role', render: (r) => <span className={`role-badge role-${r.role}`}>{r.role.replaceAll('_',' ')}</span> },
          { key: 'phone', header: 'Phone', render: (r) => r.phone || <span className="muted">—</span> },
          { key: 'isActive', header: 'Status', render: (r) => r.isActive ? <span className="badge success">Active</span> : <span className="badge neutral">Disabled</span> },
          { key: 'createdAt', header: 'Joined', render: (r) => <span className="muted">{formatDate(r.createdAt)}</span> }
        ]}
        emptyTitle="No admins yet"
      />
      <div className="callout" style={{ marginTop: 'var(--s-4)' }}>
        Promoting users to <strong>Super Admin</strong> can only be done via the backend (e.g. running
        the <code>seed:admin</code> script with that email or updating the role directly in MongoDB).
        Self-registration cannot create a Super Admin.
      </div>
      {err && <div className="notice warning" style={{ marginTop: 'var(--s-4)' }}>{err}</div>}
    </>
  );
}

export default Admins;
